import type { OgCityKey } from "@/lib/ogImages";

export const CASTLE_ROCK_PROFILE: {
  city: string;
  citySlug: OgCityKey;
  cityGeo: { lat: number; lng: number };
  zips: string[];
  neighborhoods: string[];
  nearbyCities: string[];
} = {
  city: "Castle Rock",
  citySlug: "castle-rock",
  cityGeo: { lat: 39.3722, lng: -104.8561 },
  zips: ["80104", "80108", "80109"],
  neighborhoods: [
    "Founders Village", "The Meadows", "Castle Pines",
    "Crystal Valley", "Plum Creek", "Castlewood Ranch",
    "Cobblestone Ranch", "Sapphire Pointe",
  ],
  nearbyCities: ["Parker", "Castle Pines", "Larkspur", "Sedalia"],
};
